import ResourceBlockerApp from './ResourceBlockerApp'

export default ResourceBlockerApp
